export const ERROR_MESSAGES = {
  TOO_MANY_FILES: 'Can upload only a single file',
  DIMENSION_TOO_SMALL: 'DIMENSION_TOO_SMALL',
  FILE_TOO_LARGE: 'File is too big',
  INVALID_FILE_TYPE: 'Invalid file type',
  DEFAULT: 'Unexpected error',
};
